import React, {createContext, PropsWithChildren, useContext} from 'react';
import {ActorRefFrom} from 'xstate';

import {ParameterLayerMachine} from 'samples/plate-maps/parameter-layers/machine/ParameterLayerMachine';

type ParameterLayerActor = ActorRefFrom<typeof ParameterLayerMachine>;

const ScratchPlateParameterLayerCtx = createContext<ParameterLayerActor | null>(null);

export function useScratchPlateParameterLayerActor(): ParameterLayerActor {
  const actor = useContext(ScratchPlateParameterLayerCtx);
  if (actor == null) {
    throw new Error(
      'useScratchPlateParameterLayerActor must be used within ScratchPlateParameterLayerProvider'
    );
  }
  return actor;
}

export default function ScratchPlateParameterLayerProvider({
  actor,
  children,
}: PropsWithChildren<{actor: ParameterLayerActor}>): JSX.Element {
  return (
    <ScratchPlateParameterLayerCtx.Provider value={actor}>{children}</ScratchPlateParameterLayerCtx.Provider>
  );
}
